import { ExtensionConfig, PrerequisiteRuleTypes } from '@goto/shell'
import { getFeatureFlag } from '../helpers/shell-helpers'

const extensionConfig: ExtensionConfig = {
  id: '@ucc-messaging/messaging-extension',
  get url() {
    const inboxVersion = getFeatureFlag('inbox-version', 'latest')
    return new URL(
      inboxVersion
        ? `/experiences/messaging/${inboxVersion}/messaging-extension.mjs`
        : `/experiences/messaging/messaging-extension.js`,
      location.origin,
    )
  },
  prerequisites: {
    [PrerequisiteRuleTypes.ENTITLEMENTS]: 'jive || gotoconnect || g2m',
  },
  esModule: true,
  integrationConfig: {
    shouldLoadInIntegration: true,
    shouldLoadInCompanion: true,
  },
}

export default extensionConfig
